import axios from 'axios';

async function fetchUserProfile(env) {
  const userSessionApi = `${env}/service/user/session/user`;

  try {
    const response = await axios.get(userSessionApi, {
      headers: {
        'Accept': 'application/json',
        'X-BrightTALK-access': 'niHeeF1ao2',
        'Content-Type': 'application/json',
        'BrightTALK-API-Client': 'wordpress',
      },
      withCredentials: true,
    });
    return updateUserState(response);
  } catch (error) {
    console.log('error');
    console.log(error);
  }
}

export function updateUserState(response) {
  const data = response.data;

  // Check if response returns any roles for user.
  let roles = false;
  if (data['roles'] !== undefined) {
    if (data['roles'].includes('manager') || data['roles'].includes('operations')) {
      roles = true;
    }
  }

  //
  let preAuth = false;
  if (data['preAuth'] === undefined) {
    preAuth = false;
  } else if (data['preAuth'] === true) {
    preAuth = true;
  }
  if (data) {
    return {
      isLoggedIn: true,
      isManager: roles,
      preAuth: preAuth,
      timeZone: data.timeZone,
    };
  }
}

export default fetchUserProfile;
